import React, { useState, useImperativeHandle, forwardRef } from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

//images
import closeIcon from '../../../assets/images/profile/messages/close.png'
import videoIcon from '../../../assets/images/profile/messages/video.png'
import btnVideoIcon from '../../../assets/images/profile/messages/btn-video.png'

function VideosMessage(props, ref) {
    const initialState = {
        heading: '',
        description: '',
        url: '',
        button: '',
        buttonAccess: ''
    }
    const [state, setState] = useState({
        blur: false,
        popup: false,
        ...initialState
    })

    useImperativeHandle(ref, () => ({
        open: (heading, description, url, button, buttonAccess) => handleOpen(heading, description, url, button, buttonAccess),
        close: () => handleClose()
    }))

    const handleOpen = (heading, description, url, button, buttonAccess) => {
        setState(state => ({
            ...state,
            blur: true,
            heading,
            description,
            url,
            button,
            buttonAccess
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={state.blur ? 'visible' : ''}>
            <div className={`box videos-message ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                />
                <img src={videoIcon} alt="video" className="main-img" />
                <h2>
                    {state.heading}
                </h2>
                <p>
                    {state.description}
                </p>
                <div className="buttons">

                    <Link
                        to={state.url}
                        onClick={e => {
                            if (state.buttonAccess == false) {
                                e.preventDefault()
                                props.handleVideoTutorial()
                            }
                        }}
                    >
                        <Button style={{ width: '320px' }}>
                            <img src={btnVideoIcon} alt="video" />
                            Към лекциите от Тема {state.button}
                        </Button>
                    </Link>

                </div>
            </div>
        </div >
    )
}

export default forwardRef(VideosMessage)